/* eslint-disable */
import { logger } from 'module/logger';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { GroupedOptions } from 'module/types/filter-field/field/grouped-field';
import {
  defaultGroupedFilter,
  GroupedFilter as GroupedFilterType,
} from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { GroupedFilterPopover } from 'module/ui/components/molecules/field-filter/popover/grouped-filter-popover/popover';
import { useCallback, useState } from 'react';
import { SignalListDropdown } from './signal-list-dropdown';
import { AccountHeaderWrapper } from './styles';
import { SignalType } from 'api/signal/types';
import { ManageViewDrawer } from 'components/organisms/views/manage-view-drawer';

interface View {
  viewName: string;
  filter: any;
  signalType?: SignalType;
  myAccountSignalType?: SignalType;
  selectedSignals?: string[];
  self?: boolean;
}

export const AccountHeader = ({
  groupedFields,
  filter: value,
  onChange,
  onDone,
  onCancel,
  selectedSignals,
  setSelectedSignals,
  onSaveView,
  onUpdateView,
  isViewSelected,
  filtersChanged,
  currentViewName,
  isAccountPage = false,
}: {
  groupedFields?: GroupedOptions<FilterableField>[];
  filter?: GroupedFilterType;
  onChange?: (filter: GroupedFilterType) => void;
  onDone?: () => void;
  onCancel?: () => void;
  setSelectedSignals: (signals: string[]) => void;
  selectedSignals: string[];
  onSaveView?: (data: {
    name: string;
    filter: any;
    viewAvailability: string;
  }) => Promise<void>;
  onUpdateView?: (data: {
    name: string;
    filter: any;
    viewAvailability: string;
  }) => Promise<void>;
  isViewSelected?: boolean;
  filtersChanged?: boolean;
  currentViewName?: string;
  isAccountPage?: boolean;
}) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [editingView, setEditingView] = useState<View | null>(null);

  const filter = value || defaultGroupedFilter(FilterGroupType.Company);

  const handleSaveView = useCallback(() => {
    setEditingView(null);
    setIsDrawerVisible(true);
  }, []);

  const handleUpdateView = useCallback(() => {
    if (currentViewName) {
      setEditingView({
        viewName: currentViewName,
        filter: filter as any,
        self: true,
      });
      setIsDrawerVisible(true);
    }
  }, [currentViewName, filter]);

  const handleDrawerClose = () => {
    setIsDrawerVisible(false);
    setEditingView(null);
  };

  const handleDrawerSave = async (updatedView: View) => {
    try {
      if (editingView) {
        await onUpdateView?.({
          name: updatedView.viewName,
          filter: updatedView.filter,
          viewAvailability: updatedView.self ? 'ONLY_ME' : 'ALL_TEAM_MEMBERS',
        });
      } else {
        await onSaveView?.({
          name: updatedView.viewName,
          filter: updatedView.filter,
          viewAvailability: updatedView.self ? 'ONLY_ME' : 'ALL_TEAM_MEMBERS',
        });
      }
    } catch (error) {
      logger.error('Error saving view', { error });
    } finally {
      handleDrawerClose();
    }
  };

  return (
    <AccountHeaderWrapper
      className="account-header"
      $isAccountPage={isAccountPage}
    >
      <GroupedFilterPopover
        fields={groupedFields ?? []}
        filter={filter as any}
        onChange={onChange ?? (() => {})}
        loading={false}
        reset={onCancel ?? (() => {})}
        onDone={onDone ?? (() => {})}
        onSaveView={handleSaveView}
        onUpdateView={handleUpdateView}
        isViewSelected={isViewSelected}
        filtersChanged={filtersChanged || false}
      />

      <SignalListDropdown
        filter={filter}
        onChange={onChange}
        selectedSignals={selectedSignals}
        setSelectedSignals={setSelectedSignals}
      />

      <ManageViewDrawer
        isDrawerVisible={isDrawerVisible}
        onClose={handleDrawerClose}
        editingView={editingView}
        onSave={handleDrawerSave}
        filter={filter as any}
      />
    </AccountHeaderWrapper>
  );
};
